import { useRootStore } from "../RootStateContext";

export const useReportsStore = () => {
  const rootStore = useRootStore();

  if (!rootStore?.reportsStore) {
    throw new Error('reportsStore store should be defined');
  }

  return rootStore.reportsStore;
}